function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
parcelRequire = function (e, r, n, t) {
  var i = "function" == typeof parcelRequire && parcelRequire,
    o = "function" == typeof require && require;
  function u(n, t) {
    if (!r[n]) {
      if (!e[n]) {
        var f = "function" == typeof parcelRequire && parcelRequire;
        if (!t && f) return f(n, !0);
        if (i) return i(n, !0);
        if (o && "string" == typeof n) return o(n);
        var c = new Error("Cannot find module '" + n + "'");
        throw c.code = "MODULE_NOT_FOUND", c;
      }
      p.resolve = function (r) {
        return e[n][1][r] || r;
      };
      var l = r[n] = new u.Module(n);
      e[n][0].call(l.exports, p, l, l.exports, this);
    }
    return r[n].exports;
    function p(e) {
      return u(p.resolve(e));
    }
  }
  u.isParcelRequire = !0, u.Module = function (e) {
    this.id = e, this.bundle = u, this.exports = {};
  }, u.modules = e, u.cache = r, u.parent = i, u.register = function (r, n) {
    e[r] = [function (e, r) {
      r.exports = n;
    }, {}];
  };
  for (var f = 0; f < n.length; f++) u(n[f]);
  if (n.length) {
    var c = u(n[n.length - 1]);
    "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = c : "function" == typeof define && define.amd ? define(function () {
      return c;
    }) : t && (this[t] = c);
  }
  return u;
}({
  "Focm": [function (require, module, exports) {
    "use strict";

    function t(n) {
      return n.reduce(function (n, e) {
        return Array.isArray(e.options) ? n.concat(t(e.options)) : n.concat(e);
      }, []);
    }
    Object.defineProperty(exports, "__esModule", {
      value: !0
    });
    var n = function n(t) {
        return t.trim();
      },
      e = function e(t) {
        return t.split(",").map(n);
      },
      r = function r(t) {
        return t.join(",");
      };
    function u(n, r, u, i) {
      if (void 0 !== r) {
        var o = t(n);
        return i ? o.filter(function (t) {
          return e(r).includes(u(t));
        }) : o.find(function (t) {
          return u(t) === r;
        });
      }
    }
    var i = function i(t) {
      return t.value;
    };
    function o(t) {
      var n = t.children,
        e = t.defaultValue,
        r = t.getOptionValue,
        o = void 0 === r ? i : r,
        a = t.isMulti,
        c = void 0 !== a && a,
        l = t.options,
        f = u(l, t.value, o, c);
      return n({
        defaultValue: u(l, e, o, c),
        getOptionValue: o,
        isMulti: c,
        options: l,
        value: f
      });
    }
    exports.default = o;
  }, {}]
}, {}, ["Focm"], null);